export default function Privacy() {
  return (
    <div style={{ padding: '80px 20px 100px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> March 30, 2025</p>

      <p>At Screen to Scene, your privacy is important to us. This Privacy Policy outlines the types of information we collect and how we use, store, and protect it.</p>

      <h2>1. Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <ul>
        <li><strong>Personal Information:</strong> such as your name, email address, and other identifying details you provide when signing up or interacting with our site.</li>
        <li><strong>Usage Data:</strong> including information about how you use our website (e.g. pages visited, time spent on site).</li>
        <li><strong>Device Information:</strong> such as browser type, IP address, and device type.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Provide and improve our services</li>
        <li>Respond to inquiries and support requests</li>
        <li>Send service-related updates and notifications</li>
        <li>Analyze usage to improve our content and user experience</li>
      </ul>

      <h2>3. Sharing Your Information</h2>
      <p>We do not sell, rent, or trade your personal information. We may share your data with trusted third parties who help us operate the site, as long as they agree to keep it confidential.</p>

      <h2>4. Cookies & Tracking</h2>
      <p>We may use cookies or similar technologies to understand how users interact with the site. You can control cookies through your browser settings.</p>

      <h2>5. Data Security</h2>
      <p>We take reasonable steps to protect your data using modern security practices. However, no method of online transmission is 100% secure.</p>

      <h2>6. Your Rights</h2>
      <p>You may request access to your personal data, ask us to correct or delete it, or opt out of communications at any time.</p>

      <h2>7. Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. Any changes will be posted here with an updated effective date.</p>

      <h2>8. Contact Us</h2>
      <p>If you have any questions about this policy, please contact us at support@screentoscreen.com.</p>
    </div>
  );
}
